// Footer component - Converted from components/Footer.vue
// Site footer with contact information, links, and scroll-to-top button
import React, { useState, useEffect } from 'react';
import footerFarmImg from '../assets/images/resources/site-footer-farm.png';

const Footer: React.FC = () => {
  const [scrollBtn, setScrollBtn] = useState<boolean>(false);

  // Handle scroll for scroll-to-top button - converted from Vue handleScroll
  useEffect(() => {
    const handleScroll = () => {
      setScrollBtn(window.scrollY > 70);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Scroll to top function - converted from Vue scrollTop
  const scrollTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <footer className="site-footer overflow-hidden" >
        <div className="site-footer_farm_image">
          <img src={footerFarmImg} alt="Farm Image" />
        </div>
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="footer-widget__column footer-widget__about wow fadeInUp" data-wow-delay="100ms">
                <div className="footer-widget__title">
                  <h3>À propos</h3>
                </div>
                <div className="footer-widget_about_text">
                  <p>
                    Leaders Agro Elite est une entreprise tunisienne dévouée à
                    l&apos;excellence agricole, offrant des produits de qualité
                    supérieure et des solutions innovantes pour un avenir durable.
                  </p>
                </div>
                <form>
                  <div className="footer_input-box">
                    <input type="Email" placeholder="Adresse e-mail" />
                    <button type="submit" className="button">
                      <i className="fa fa-check"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="footer-widget__column footer-widget__link wow fadeInUp" data-wow-delay="200ms">
                <div className="footer-widget__title">
                  <h3>Explorer</h3>
                </div>
                <ul className="footer-widget__links-list list-unstyled">
                  <li><a href="#">À propos de nous</a></li>
                  <li><a href="#">Services</a></li>
                  <li><a href="#">Nos projets</a></li>
                  <li><a href="#">Contact</a></li>
                </ul>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="footer-widget__column footer-widget__contact wow fadeInUp" data-wow-delay="400ms">
                <div className="footer-widget__title">
                  <h3>Contact</h3>
                </div>
                <div className="footer-widget_contact">
                  <p>Les berges du lac2, Tunis</p>
                  <a href="mailto:leadersagroelite@gmail.com">leadersagroelite@gmail.com</a><br />
                  <a href="tel:+21627920900">27 920 900</a>
                  <div className="site-footer__social">
                    <a
                      href="https://www.facebook.com/people/Leaders-Agro-Elite/61585236126030/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-square"></i>
                    </a>
                    <a href="https://www.instagram.com/leadersagroelite/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="site-footer_bottom">
        <div className="container">
          <div className="site-footer_bottom_copyright">
            <p>© Tous droits réservés 2026, Leaders Agro Elite</p>
          </div>
          <div className="site-footer_bottom_menu">
            <ul className="list-unstyled">
              <li><a href="#">Politique de confidentialité</a></li>
              <li><a href="#">Conditions d&apos;utilisation</a></li>
            </ul>
          </div>
        </div>
      </div>

      <a 
        onClick={scrollTop} 
        href="#" 
        className="scroll-to-target scroll-to-top"
        style={{ display: scrollBtn ? 'block' : 'none' }}
      >
        <i className="fa fa-angle-up"></i>
      </a>
    </div>
  );
};

export default Footer;

